// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e99c39b2","488":"40727e6e"}[chunkId] + ".chunk.js";
};